@if (showAvailable) {
  <section class="referral-credit-ready mx-4 mx-md-0" data-id="referral-credit-banner">
    <img
      [src]="REFERRAL_ENVELOPE_IMAGE"
      alt=""
      width="120"
      height="120"
      class="referral-credit-ready__art-mobile d-md-none"
    />

    <div class="referral-credit-ready__content">
      <h2 class="referral-credit-ready__title">
        Your {{ referralCredit?.amount ?? 0 | portalCurrency: true }} referral credit is ready!
      </h2>
      <p class="referral-credit-ready__text">
        Use your {{ referralCredit?.amount ?? 0 | portalCurrency: true }} credit toward any one of
        these flight options. It will be deducted from your total booking price.
      </p>
      <p class="referral-credit-ready__text referral-credit-ready__footnote">
        Book within {{ bookingWindowLabel }}. Travel later.
      </p>
    </div>

    <img
      [src]="REFERRAL_ENVELOPE_IMAGE"
      alt=""
      width="360"
      class="referral-credit-ready__art d-none d-md-block"
    />
  </section>
} @else if (showApplied) {
  <ds-info-block class="referral-credit-banner mx-4 mx-md-0 mt-4" data-id="referral-credit-applied">
    Your {{ referralCredit?.amount ?? 0 | portalCurrency: true }} referral travel credit has been
    applied to this booking.
  </ds-info-block>
}
